import { Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { Trans } from 'react-i18next';

type FormCharacterCountProps = {
  name: string; // Fältet i formuläret vars tecken ska räknas
};

// Visar antal tecken i ett formulärfält, med samma utseende som teckenräknaren i SMS-utskick.
// Måste ligga inuti en FormProvider.
export const FormCharacterCount = (props: FormCharacterCountProps) => {
  const { name } = props;
  const { control } = useFormContext();
  const value = useWatch({ control, name });

  return (
    <Typography component='div' variant='body1' sx={{ fontWeight: 100, my: 1 }}>
      <Trans i18nKey='common:characterCount' values={{ length: (value ?? '').length }} />
    </Typography>
  );
};
